import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import minMax from "dayjs/plugin/minMax";
import weekday from "dayjs/plugin/weekday";
import "dayjs/locale/en-gb";

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(minMax);
dayjs.extend(weekday);

// Weeks start on Monday, which the calendar layout and working hours' dayOfWeek both rely on
dayjs.locale("en-gb");

// Working hours come from the API as .NET TimeSpan strings, e.g. "09:30:00"
export function setDateTime(date: Dayjs, timeSpan: string | undefined) {
  if (!timeSpan) return date;
  const [hours, minutes, seconds = 0] = timeSpan.split(":").map(Number);
  return date.add(hours, "hour").add(minutes, "minute").add(seconds, "second");
}

export function toISOStringIfValid(date: Date | undefined) {
  if (date === undefined) return undefined;
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.toISOString() : undefined;
}

export default dayjs;
